import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/common/btn_close.png'


const _hoisted_1 = { class: "mask display-x-center display-y-center" }
const _hoisted_2 = { class: "tip-content-a" }
const _hoisted_3 = ["src"]

import { useI18n } from 'vue-i18n';
import { receiveNewUserReward } from '@/api/v4';
import { LOCAL_STORE } from '@/config/constConfig';


export default /*@__PURE__*/_defineComponent({
  __name: 'NewPlayerTip',
  emits: ["onClose"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const emits = __emit;

function onConfirm() {
    emits('onClose');
    receiveNewUserReward({}).then((res: any) => {
        if (res.data.success) {
            localStorage.setItem(LOCAL_STORE.IS_SHOW_NEWPLAYER, "1");
        }
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "content-bg",
        src: require('@/assets/images/home/prop/' + _unref(t)('activitys.img.4'))
      }, null, 8, _hoisted_3),
      _createElementVNode("div", {
        class: "btn-confirm",
        onClick: onConfirm
      }),
      _createElementVNode("img", {
        class: "btn-close",
        src: _imports_0,
        onClick: onConfirm
      })
    ])
  ]))
}
}

})